// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types'; // Material UI

import { IconButton, Tooltip } from '@material-ui/core';
export var ActionButton = function ActionButton(_ref) {
  var iconButton = _ref.iconButton,
      handleClick = _ref.handleClick,
      Icon = _ref.icon,
      toolTipTitle = _ref.toolTipTitle;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: toolTipTitle
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: iconButton,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(Icon, null)));
};
ActionButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  icon: PropTypes.object,
  iconButton: PropTypes.string,
  toolTipTitle: PropTypes.string.isRequired
};
ActionButton.defaultProps = {
  iconButton: 'light'
};